import React from 'react';
import { Collapse, Icon } from 'antd';
import { STATUS_MONITORING as trans } from '../../containers/Dashboard/StatusMonitoring/TranslationValues';
import { withTranslation } from 'react-i18next';

const { Panel } = Collapse;
const namespaces = ['STATUS_MONITORING'];
const ReusableDynamicCollapse = ({
  bordered = false,
  defaultActiveKey = ['1'],
  expandIcon = 'caret-right',
  styles,
  panelData,
  expandIconStyles = {},
  className = 'reusable-dynamic-collapse',
  panelClassName = 'dynamic-collapse-panel',
  accordion = true, // In accordion mode, only one panel can be expanded at a time.
  onChange = () => {},
  activeKey=['1'],
  extra,
  channelTotals,
  isPrintingModal,
  t
}) => {
  const isPanelDisabled = panel => {
    if (panel.key === ' Documents') {
      return channelTotals.print === 0;
    } else if (panel.key === ' Email') {
      return channelTotals.email === 0;
    } else if (panel.key === 'Hybrid') {
      return channelTotals.hybrid === 0;
    } else return channelTotals.message === 0;
  };
  const getPanelHeader = panel => {
    const noDataText =
      panel.header + ' (' + t(trans.NO_DATA_TEXT.key, trans.NO_DATA_TEXT.value) + ')';
    if (panel.key === 'Documents') {
      return isPrintingModal
        ? t(trans.EXCLUDE_DOCUMENTS_FOR_PRINTING.key, trans.EXCLUDE_DOCUMENTS_FOR_PRINTING.value)
        : channelTotals.print > 0
        ? panel.header
        : noDataText;
    } else if (panel.key === 'Email') {
      return isPrintingModal
        ? t(trans.EXCLUDE_EMAILS_FROM_DELIVERY.key, trans.EXCLUDE_EMAILS_FROM_DELIVERY.value)
        : channelTotals.email > 0
        ? panel.header
        : noDataText;
    } else if (panel.key === 'Hybrid') {
      return isPrintingModal
        ? t(trans.EXCLUDE_LETTERS_FOR_PRINTING.key, trans.EXCLUDE_LETTERS_FOR_PRINTING.value)
        : channelTotals.Hybrid > 0
        ? panel.header
        : noDataText;
    } else return channelTotals.message > 0 ? panel.header : noDataText;
  };
  return (
    <Collapse
      activeKey={activeKey}
      destroyInactivePanel={true}
      bordered={bordered}
      defaultActiveKey={defaultActiveKey}
      expandIcon={!isPrintingModal ? ({ isActive }) => (
        <Icon type={expandIcon} rotate={isActive ? 90 : 0} style={expandIconStyles} />
      ) : null}
      style={styles}
      className={className}
      accordion={accordion}
      onChange={onChange}
    >
      {panelData.map((panel, index) => (
        <Panel
          header={getPanelHeader(panel)}
          key={panel.key || index.toString()}
          style={panel.style}
          className={panelClassName}
          extra={extra && isPrintingModal && extra(panel.header)}
          disabled={isPanelDisabled(panel)}
          showArrow={!isPrintingModal}
        >
          {panel.content}
        </Panel>
      ))}
    </Collapse>
  );
};

export default withTranslation(namespaces)(ReusableDynamicCollapse);
